export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9806.b1dc7425.jpg";